import moment from 'moment';
import React from 'react';
import styles from './OldRequest.module.scss';
import { Icon, Tooltip } from 'antd';

const PREFIX_COLORS = {
  orange: '#F4A649',
  light_orange: '#fcbc62',
  green: '#4DCD00',
  marsh: '#97CDAA',
  blue: '#137DEC',
  light_blue: '#71b8e4',
};

export const OldRequest = ({
  id,
  parentServiceName,
  serviceName,
  createDate,
  executeDate,
  isImmediate = false,
  isRetry = false,
  isInternal = false,
  isChargeable = false,
  garanty = false,
  typeRequest,
  stateName,
  createUser,
}) => {
  const createDateTime = moment(createDate).format('DD.MM.YY HH:mm');
  const executeDateTime = moment(executeDate).format('DD.MM.YY HH:mm');

  return (
    <li className={styles.root}>
      <div className={styles.left_block}>
        <div>
          Заявка{' '}
          <Tooltip
            getPopupContainer={(trigger) => trigger.parentElement}
            title="Открыть на новой вкладке"
          >
            <a
              href={`/Requests/${id}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.req_link}
            >
              № {id}
            </a>
          </Tooltip>
        </div>

        <div>Услуга: {parentServiceName}</div>
        <div>Причина: {serviceName}</div>
        <div>
          {createDateTime} - {executeDateTime}
        </div>
      </div>
      <div className={styles.right_block}>
        <div className={styles.prefixes}>
          {isImmediate && (
            <Tooltip
              title="Аварийная"
              getPopupContainer={(trigger) => trigger.parentElement}
            >
              <div className={styles.fire_anticon}>
                <Icon
                  type="fire"
                  className={styles.fire_icon}
                />
              </div>
            </Tooltip>
          )}
          {stateName && (
            <div
              style={{
                backgroundColor: PREFIX_COLORS.blue,
              }}
              className={styles.prefix}
            >
              {stateName}
            </div>
          )}
          {isChargeable && (
            <div
              style={{
                backgroundColor: PREFIX_COLORS.green,
              }}
              className={styles.prefix}
            >
              Платная
            </div>
          )}
          {garanty && (
            <div
              style={{
                backgroundColor: PREFIX_COLORS.marsh,
              }}
              className={styles.prefix}
            >
              Гарантийная
            </div>
          )}
          {isInternal && (
            <div
              style={{
                backgroundColor: PREFIX_COLORS.light_blue,
              }}
              className={styles.prefix}
            >
              Внутренняя
            </div>
          )}
          {isRetry && (
            <div
              style={{
                backgroundColor: PREFIX_COLORS.light_orange,
              }}
              className={styles.prefix}
            >
              Повторная
            </div>
          )}
          {typeRequest && (
            <div
              style={{
                backgroundColor: PREFIX_COLORS.orange,
              }}
              className={styles.prefix}
            >
              {typeRequest}
            </div>
          )}
        </div>
        {createUser && <div className={styles.createUser}>{createUser}</div>}
      </div>
    </li>
  );
};
